module.exports = __webpack_public_path__ + "res/27-img_game_bg_t_l.52f3c64247f8458e27c5306206fded58.png";